import type React from "react";
import { useLocation, Link, Outlet } from "react-router-dom";
import { ArrowLeft, User, Mail, Rocket } from "lucide-react";
import { cn } from "../../lib/utils";
import authBg from "../../assets/images/auth-bg.png";
import godump from "../../assets/images/godump-logo.png";

export function LayoutProvider() {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
     {!['/signin', '/reset-password'].includes(pathname) && <aside
        className="h-full relative w-[400px] bg-white p-8 hidden lg:flex flex-col justify-between"
      >
        <div className="space-y-8 flex-1 border border-black">
          <img
            className=" absolute top-0 left-0 w-full h-full "
            src={authBg}
            alt={authBg}
            width="100"
          />

          <div className="space-y-8 relative">
            <div className="">
              <Link to="/" className="text-2xl font-bold">
                <img className=" " src={godump} alt={godump} width="100" />
              </Link>
            </div>
            {pathname !== "login" && (
              <>
                <SidebarItem
                  icon={<User className="h-5 w-5" />}
                  title="Your details"
                  description="Provide company and personal details"
                  isActive={pathname === "/register" || pathname === "/"}
                />

                <SidebarItem
                  icon={<Mail className="h-5 w-5" />}
                  title="Verification"
                  description="Email and business verification"
                  isActive={pathname === "/verification"}
                />

                <SidebarItem
                  icon={<Rocket className="h-5 w-5" />}
                  title="Welcome to godump"
                  description="Setup your fleet"
                  isActive={pathname === "/welcome"}
                />
              </>
            )}
          </div>
        </div>

        {/* Bottom navigation */}
        <div className="w-full flex justify-between pt-8 mt-auto absolute left-0 px-8 bottom-10">
          <Link to="/" className=" flex items-center gap-4 font-medium">
            <ArrowLeft className="h-4 w-4" />
            Back home
          </Link>
          <Link
            to={pathname === "/signin" ? "/register" : "/signin"}
            className="font-medium"
          >
            {pathname === "/signin" ? "Sign up" : "Sign in"}
          </Link>
        </div>
      </aside>}

      {/* Main content */}
      <main className="h-full overflow-auto flex-1 p-4 md:p-8">{<Outlet/>}</main>
    </div>
  );
}

interface SidebarItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  isActive?: boolean;
}

function SidebarItem({
  icon,
  title,
  description,
  isActive = false,
}: SidebarItemProps) {
  return (
    <div className="flex items-start gap-4">
      <div
        className={cn(
          "rounded-full p-2 mt-1",
          isActive ? "text-black" : " text-gray-400"
        )}
      >
        {icon}
      </div>
      <div>
        <h3
          className={cn(
            "font-medium text-gray-900",
            isActive ? "text-black" : " text-gray-400"
          )}
        >
          {title}
        </h3>
        <p
          className={cn(
            "text-sm text-gray-500",
            isActive ? "text-black" : " text-gray-400"
          )}
        >
          {description}
        </p>
      </div>
    </div>
  );
}
